<template>
  <thead
    class="border border-solid border-l-0 border-r-0 bg-blueGray-50 border-blueGray-100"
  >
    <tr>
      <ColumnHeader :title="'Title'" @click="order('title')" />
      <ColumnHeaderWithoutSelector :title="'Image'" />
      <ColumnHeaderWithoutSelector :title="'Product Skus'" />
      <ColumnHeaderWithoutSelector :title="'Related Skus'" />
      <ColumnHeaderWithoutSelector :title="'Tags'" />
      <ColumnHeader :title="'Date Added'" @click="order('date_added')" />
      <ColumnHeaderWithoutSelector :title="'Modified by'" />
      <ColumnHeaderWithoutSelector :title="'Operation'" />
    </tr>
  </thead>
</template>

<script>
import ColumnHeader from "@/components/Shared/Table/ColumnHeader";
import ColumnHeaderWithoutSelector from "@/components/Shared/Table/ColumnHeaderWithoutSelector";

export default {
  name: "ImageTableHead",
  components: {
    ColumnHeader,
    ColumnHeaderWithoutSelector
  },
  props: {
    order: {
      type: Function,
      required: true
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>
